// extracted by mini-css-extract-plugin
export default {"iconContainer":"Clubs-Change-Stadium-Capacity_iconContainer__lLmT9","wrapContainer":"Clubs-Change-Stadium-Capacity_wrapContainer__vENvR"};